import type { Assets } from '../core/assets.js';
import type { Screen } from '../core/screen.js';
import { joinArena, type ArenaClient } from '../net/arena.js';
export class NetworkScene {
  private panel: HTMLDivElement | null = null;
  private readonly abort = new AbortController();
  private client: ArenaClient | null = null;
  private started = false;
  constructor(
    private readonly screen: Screen,
    private readonly assets: Assets,
    private readonly onGame: (client: ArenaClient) => void,
    private readonly onBack: () => void,
  ) {}
  attach(): void {
    const panel = document.createElement('div');
    this.panel = panel;
    Object.assign(panel.style, {
      position: 'fixed',
      inset: '10%',
      zIndex: '10',
      background: '#eee8d1',
      color: '#203846',
      padding: '20px',
      overflow: 'auto',
      fontFamily: 'monospace',
      touchAction: 'auto',
      border: '4px solid #27a8a1',
    });
    const title = document.createElement('h2');
    title.textContent = 'biplanes.io — FFA';
    panel.append(title);
    const help = document.createElement('p');
    help.textContent =
      'Join the ongoing arena. Every pilot flies for themselves. No account needed.';
    panel.append(help);
    const form = document.createElement('form');
    const label = document.createElement('label');
    label.textContent = 'Nickname ';
    const name = document.createElement('input');
    name.name = 'nickname';
    name.setAttribute('autocomplete', 'nickname');
    name.maxLength = 16;
    name.required = true;
    name.pattern = '[A-Za-z0-9 _\\-]{1,16}';
    name.setAttribute('aria-label', 'Nickname');
    label.append(name);
    form.append(label);
    try {
      name.value = localStorage.getItem('biplanes.nickname') ?? '';
    } catch {
      /* Session-only nickname is fine. */
    }
    const pilot = document.createElement('select');
    pilot.setAttribute('aria-label', 'Your pilot');
    this.assets.strings.tm.slice(3, 7).forEach((pilotName, index) => {
      const option = document.createElement('option');
      option.value = String(index);
      option.textContent = pilotName;
      pilot.append(option);
    });
    form.append(pilot);
    const join = document.createElement('button');
    join.type = 'submit';
    join.textContent = 'Join FFA';
    form.append(join);
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    form.append(status);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      join.disabled = true;
      status.textContent = 'Joining the arena...';
      void joinArena(name.value.trim(), Number(pilot.value), this.abort.signal)
        .then((client) => {
          if (this.abort.signal.aborted) {
            client.close();
            client.free();
            return;
          }
          try {
            localStorage.setItem('biplanes.nickname', name.value.trim());
          } catch {
            /* Optional preference storage. */
          }
          this.client = client;
          this.started = true;
          this.onGame(client);
        })
        .catch((error: unknown) => {
          if (!this.abort.signal.aborted) {
            status.textContent = error instanceof Error ? error.message : String(error);
            join.disabled = false;
          }
        });
    });
    panel.append(form);
    const back = document.createElement('button');
    back.textContent = 'Back';
    back.addEventListener('click', this.onBack);
    panel.append(back);
    document.body.append(panel);
    name.focus();
  }
  detach(): void {
    this.abort.abort();
    this.panel?.remove();
    if (!this.started) {
      this.client?.close();
      this.client?.free();
    }
    this.panel = null;
  }
  update(): void {}
  render(_fps: number): void {
    this.screen.clear('#b9dce0');
  }
}
